<template>
  <a-form-item
    class="m-form-item"
    label="房间号"
    :wrapper-col="labelCol.wrapperCol"
    :label-col="labelCol.labelCol">
      <a-select
        @search="handleSearchCustomer"
        @change="handleChangeCustomer"
        :showArrow="false"
        :allowClear="true"
        showSearch
        :filterOption="false"
        notFoundContent="暂无数据"
        v-decorator="[
          'meeting_id',
          {
            rules: isNeed ? [{ required: true, message: '请输入关键字搜索房间号' }] : [] }
        ]"
        :disabled="disabled"
        placeholder="请输入关键字搜索房间号">
          <div class="search-loading" v-if="isFetching" slot="notFoundContent">
            <a-spin size="small" />
          </div>
          <a-select-option v-for="item in filterCustomers"
            :value="item.id"
            :key="item.id">{{item.title}}</a-select-option>
      </a-select>
  </a-form-item>
</template>

<script>
import product from '@/api/product';

export default {
  name: 'MMettingSelect',
  props: {
    labelCol: {
      type: Object,
      default: () => ({
        wrapperCol: { span: 18 },
        labelCol: { span: 6 }
      }),
    },
    disabled: {
      default: false,
    },
    building_id: [Number, String],
    isNeed: Boolean,
    customer_id: [Number, String],
  },
  data() {
    return {
      isFetching: false,
      customers: [],
      keywords: '',
    }
  },
  computed: {
    filterCustomers() {
      return this.customers.filter(item => !this.keywords || item.title.includes(this.keywords));
    }
  },
  created() {
    this.getBuildings();
  },
  methods: {
    getBuildings() {
      console.log('get buildings');
      this.isFetching = true;
      product.apiGetMettings({
        page: 1,
        customer_id: this.customer_id,
        building_id: this.building_id,
        pagesize: 9999,
      })
      .then((data) => {
        this.customers = data.list;
        this.isFetching = false;
      })
      .catch(() => {
        this.isFetching = false;
      });
    },
    handleSearchCustomer(value) {
      this.keywords = value;
    },
    handleChangeCustomer(value) {
      this.$emit('change', value);
    }
  },
  watch: {
    building_id() {
      this.getBuildings();
    },
    customer_id() {
      this.getBuildings();
    },
  }
}
</script>

<style>
.m-form-item {
  min-width: 280px;
}
</style>


// WEBPACK FOOTER //
// src/components/product/metting-select.vue